module.exports = __webpack_public_path__ + "img/img-0-pi.9e0b03e6.png";